import React, { useRef, useEffect, useState } from 'react';
import useOnScreen from '../hooks/useOnScreen';

const LazyLoad = ({ children, loader, ...props }) => {
  const ref = useRef();
  const onScreen = useOnScreen(ref);
  const [inView, setInView] = useState();

  useEffect(() => {
    if (onScreen) {
      setInView(true);
    }
    return () => {};
  }, [onScreen]);

  return (
    <div
      style={{ ...(inView ? {} : { minHeight: '100px' }) }}
      {...props}
      ref={ref}
    >
      {inView && children ? children : loader || null}
    </div>
  );
};

export default LazyLoad;
